module.exports = __webpack_public_path__ + "img/RJC_LP_head@2x.4b81a62.jpg";